import * as React from "react"
import Block from "@bappweb/block"
import Image from "@bappweb/image"
import Col from "@bappweb/col"
import Element from "@bappweb/element"
import "./style.scss"

const Footer = (props) => {
  
 const currentYear = new Date().getFullYear()
  const {
    xsLeft,
    xsOffset,
    xsRight,
    mdLeft,
    mdOffset,
    mdRight,
    lgLeft,
    lgOffset,
    lgRight,
    xlLeft,
    xlOffset,
    xlRight,
    copyrightText
  } = props
  return (
    <Block type="footer" className="bapp-footer">
      <Block className="bapp-footer-wrapper bapp-container">
        <Col
          xs={xsLeft - xsOffset}
          md={mdLeft - mdOffset}
          lg={lgLeft - lgOffset}
          xl={xlLeft - xlOffset}
          xsOffset={xsOffset}
          mdOffset={mdOffset}
          lgOffset={lgOffset}
          xlOffset={xlOffset}
        >
          <Block className="page-footer-left">
            <Element className="copyright-text">
              {copyrightText + " " + currentYear}
            </Element>
          </Block>
        </Col>
        <Col
          xs={xsRight - xsOffset}
          md={mdRight - mdOffset}
          lg={lgRight - lgOffset}
          xl={xlRight - xlOffset}
        >
          <Block className="page-footer-right">
            <Image path={"./img/footer/norton.png"} className="norton-logo" />
          </Block>
        </Col>
      </Block>
    </Block>
  )
}

Footer.defaultProps = {
  xsLeft: 9,
  xsOffset: 0,
  xsRight: 3,
  smLeft: 9,
  smOffset: 0,
  smRight: 3,
  mdLeft: 9,
  mdOffset: 0,
  mdRight: 3,
  lgLeft: 9,
  lgOffset: 0,
  lgRight: 3,
  xlLeft: 9,
  xlOffset: 0,
  xlRight: 3,
  copyrightText: "Her hakkı Akbank T.A.Ş'ye aittir ©"
}

export default Footer
